// src/api/borrowerPortal/borrowerSignUp.js
import { apiPost } from "../client.js";

/**
 * Borrower Sign Up with email verification.
 * Uses: POST {{base_url}}/api/method/dynesourcerapi.api.custom_signup
 *
 * Payload shape:
 * {
 *   email: string,
 *   full_name: string,
 *   role: "Borrower",
 *   phone: string,
 *   redirect_to?: string,
 *   password?: string
 * }
 *
 * @param {{ email: string, full_name: string, phone: string, password?: string, redirect_to?: string }} params
 */
export async function borrowerSignUp({
  email,
  full_name,
  phone,
  password,
  redirect_to = "/borrower/signin",
}) {
  const base =
    typeof window !== "undefined" && window.location?.origin
      ? window.location.origin
      : "";
  const redirectUrl = base
    ? `${base}${redirect_to.startsWith("/") ? redirect_to : `/${redirect_to}`}`
    : redirect_to;

  const normalizedPhone = String(phone || "").trim().replace(/\D/g, "");

  const payload = {
    email: (email || "").trim().toLowerCase(),
    full_name: (full_name || "").trim(),
    role: "Borrower",
    phone: normalizedPhone,
    redirect_to: redirectUrl,
  };
  if (password) payload.password = password;

  const response = await apiPost(
    "/api/method/dynesourcerapi.api.custom_signup",
    payload,
    { Authorization: "" }
  );
  return response;
}

/**
 * Verify email and set password (from verification link).
 * Uses: {{base_url}}/api/method/dynesourcerapi.api.verify_and_set_password
 *
 * @param {{ key: string, email: string, new_password: string }} params
 * @returns {Promise<object>} API response
 */
export async function verifyAndSetPassword({ key, email, new_password }) {
  const payload = {
    key: (key || "").trim(),
    email: (email || "").trim().toLowerCase(),
    new_password: new_password || "",
  };

  const response = await apiPost(
    "/api/method/dynesourcerapi.api.verify_and_set_password",
    payload,
    { Authorization: "" }
  );
  return response;
}
